<script setup>
import { inject, onMounted } from "vue";
import { useProject } from "~/composables/useProject";
import PageShell from "~/components/PageShell.vue";
import JobsList from "~/components/JobsList.vue";
import GlLoadingIcon from "~/components/gitlab/GlLoadingIcon.vue";
import GlAlert from "~/components/gitlab/GlAlert.vue";

const { projectId } = defineProps({
  projectId: {
    required: true,
    type: String
  }
});

const isAdmin = inject("isAdmin", false);

const { project, loading, error, fetchProject, clearError } = useProject(projectId);

onMounted(fetchProject);
</script>

<template>
  <PageShell :breadcrumbs="[{ text: project ? project.name : '…' }]">
    <!-- Loading -->
    <div v-if="loading" class="flex justify-center py-12">
      <GlLoadingIcon size="lg" />
    </div>

    <!-- Error -->
    <GlAlert v-else-if="error" variant="danger" @dismiss="clearError">{{ error }}</GlAlert>

    <!-- Content -->
    <div v-else-if="project">
      <!-- Page title row -->
      <div class="flex items-start justify-between pb-4">
        <div>
          <h1 class="text-xl font-semibold text-[var(--gl-text-color-heading)]">
            {{ project.name }}
          </h1>
          <a
            v-if="project.webUrl"
            :href="project.webUrl"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gitlab-url"
            class="text-sm text-[var(--gl-text-color-subtle)] hover:underline"
            >{{ project.webUrl }}</a
          >
        </div>
      </div>

      <!-- Jobs / ecosystems table -->
      <JobsList
        :jobs="project.jobs"
        :is-admin="isAdmin"
        :project-id="project.id"
        :project-name="project.name"
        :project-enabled="project.enabled"
      />
    </div>
  </PageShell>
</template>
